stimulusApp.register(
  "search--destination-preload",
  class extends Stimulus.Controller {
    static values = {
      frameId: String,
    }

    eager() {
      const frame = document.getElementById(this.frameIdValue)
      if (!frame) return
      if (frame.hasAttribute("busy") || frame.hasAttribute("complete")) return
      if (frame.getAttribute("loading") !== "lazy") return

      frame.setAttribute("loading", "eager")
    }
  },
)
